// extracted by mini-css-extract-plugin
export default {"animal_weighing_form":"style_animal_weighing_form__lBSJi","weighing_form_confirmation":"style_weighing_form_confirmation__9Xf23"};